import { DatePipe, JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, inject, input, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { CartComponentStore, SavedCartComponentStore } from 'cart-data';
import { IntegerFormControl, NumberFormRangeStrategy } from 'forms-data';
import { SectionComponent } from 'page-layouts-ui';
import { CartStepperInputComponent } from '../../item/common/quantity-selector';
import { SavedCartItemResultsComponent } from '../../item/layouts/saved-cart-item/saved-cart-item-results/saved-cart-item-results.component';
import { DialogService } from 'common-ui';

@Component({
  selector: 'ideal-saved-cart-details',
  imports: [
    SavedCartItemResultsComponent,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    DatePipe,
    SectionComponent,
    JsonPipe,
    CartStepperInputComponent,
  ],
  templateUrl: './saved-cart-details.component.html',
  styleUrl: './saved-cart-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SavedCartComponentStore],
})
export class SavedCartDetailsComponent {
  private readonly _cartStore = inject(CartComponentStore);
  private readonly _dialogService = inject(DialogService);
  private readonly _savedStore = inject(SavedCartComponentStore);
  public readonly savedCartId = input.required<number>();
  protected readonly savedCart = this._savedStore.cart;

  protected readonly title = computed(() => `Saved Cart - ${this.savedCart()?.name ?? ''}`);

  protected readonly multiple = signal(1);

  protected readonly control = new IntegerFormControl(1, {
    min: 1,
    max: 999,
    step: 1,
    rangeStrategy: NumberFormRangeStrategy.Restrict,
  });

  constructor() {
    effect(() => {
      this._savedStore.selectCartById('' + this.savedCartId());
    });
  }

  protected addToCart(): void {
    const cartItems = this._savedStore.cartItems();
    const multiple = this.multiple();

    cartItems.forEach((item) => {
      const currentQuantity = this._cartStore.cartItems().find((cartItem) => cartItem.id.equals(item.id))?.quantity ?? 0;
      const newQuantity = currentQuantity + item.quantity * multiple;
      this._cartStore.updateItemQuantity(item.id, newQuantity);
    });
    this._dialogService.notice(`Added items to cart`);
  }
}
